import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgencyCouriersQueryVariables = Types.Exact<{
  agencyId: Types.Scalars['ID'];
  date?: Types.InputMaybe<Types.Scalars['Date']>;
  courierFiltering?: Types.InputMaybe<Types.CourierFiltering>;
}>;


export type AgencyCouriersQuery = { __typename?: 'Query', CouriersByAgency: Array<{ __typename?: 'Courier', courierId: number, indicative?: string | null, etaInterval: number, dailyProgresses?: { __typename?: 'DailyProgress', totalDeliveries: number, finishedDeliveries: number, cancelledDeliveries: number, finishedPickups: number, r30Retours: number, finishedLockerVisits: number, finishedPudoVisits: number, finishedC2CPickups: number } | null, deliveryStatistics?: Array<{ __typename?: 'DeliveryStatistics', noOfDeliveriesPastEta?: number | null }> | null }> };


export const AgencyCouriersDocument = gql`
    query AgencyCouriers($agencyId: ID!, $date: Date, $courierFiltering: CourierFiltering) {
  CouriersByAgency(
    agencyId: $agencyId
    date: $date
    courierFiltering: $courierFiltering
  ) {
    courierId
    indicative
    etaInterval
    dailyProgresses(date: $date) {
      totalDeliveries
      finishedDeliveries
      cancelledDeliveries
      finishedPickups
      r30Retours
      finishedLockerVisits
      finishedPudoVisits
      finishedC2CPickups
    }
    deliveryStatistics(date: $date) {
      noOfDeliveriesPastEta
    }
  }
}
    `;

/**
 * __useAgencyCouriersQuery__
 *
 * To run a query within a React component, call `useAgencyCouriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyCouriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyCouriersQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      date: // value for 'date'
 *      courierFiltering: // value for 'courierFiltering'
 *   },
 * });
 */
export function useAgencyCouriersQuery(baseOptions: Apollo.QueryHookOptions<AgencyCouriersQuery, AgencyCouriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyCouriersQuery, AgencyCouriersQueryVariables>(AgencyCouriersDocument, options);
      }
export function useAgencyCouriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyCouriersQuery, AgencyCouriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyCouriersQuery, AgencyCouriersQueryVariables>(AgencyCouriersDocument, options);
        }
export type AgencyCouriersQueryHookResult = ReturnType<typeof useAgencyCouriersQuery>;
export type AgencyCouriersLazyQueryHookResult = ReturnType<typeof useAgencyCouriersLazyQuery>;
export type AgencyCouriersQueryResult = Apollo.QueryResult<AgencyCouriersQuery, AgencyCouriersQueryVariables>;